/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DetailTenantModel {
    getFixupPrototypeFunction() { return DetailTenantModel.fixupPrototype; }

    static newInstance(model: Partial<DetailTenantModel>): DetailTenantModel {
        let obj = Object.assign(new DetailTenantModel(), model);
        DetailTenantModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DetailTenantModel>): DetailTenantModel {
        if (!model) return null;
        return DetailTenantModel.newInstance(<DetailTenantModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DetailTenantModel) {
        if (!obj) return;

        models.DetailTenantModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DetailTenantModel): boolean {
        Object.setPrototypeOf(obj, DetailTenantModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.roles) {
            for (let val of this.roles) {
                models.Role.fixupPrototype(val);
            }
        }
        if (this.dimension_settings) {
            for (let val of this.dimension_settings) {
                models.DimensionTenantSettings.fixupPrototype(val);
            }
        }
    }

    /**
     * Id of the tenant. This will be used for performing tenant level operations such as createPolicy, createScript, onboardCloudAccount and so on.
     */
    id: string;

    /**
     * Unique name of the tenant provided as input when creating.
     */
    name: string;

    /**
     * Roles for a particular tenant
     */
    roles: Array<models.Role>;

    /**
     * If user created under particular tenant it will be set to True or else False
     */
    is_default: boolean;

    /**
     * Entitlements for a particular tenant
     */
    service_accounts: Array<string>;

    /**
     * Policy for a particular tenant
     */
    policy: { [key: string]: Array<string>; };

    /**
     * Services applicable for a particular tenant
     */
    services: { [key: string]: Array<string>; };

    /**
     * Dimension settings for a particular tenant
     */
    dimension_settings: Array<models.DimensionTenantSettings>;

}
